import React from "react";
import DigitalAudit from "../../components/digitalAudit/DigitalAudit";

export default function Profile() {
  return <DigitalAudit />;
}
